// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"6cd8138f53753de57b6a","691":"ccb6dcf0f7e5aefd8fe6"}[chunkId] + ".js";
};